module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-ar-ebcdc67c.svg";